<template>
    <FormCard>
        <template #cardTitle>
            ACCOUNT INFORMATION
        </template>
        <template #cardSubtitle>
            The portion below is automatically filled-out by the system. If you think there are issues with these information, please contact HMI.
        </template>
        <template #cardText>
            <v-text-field
                label="ACCOUNT:"
                :value="getInfo.ACCOUNT"
                color="teal"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="EFFECTIVITY DATE:"
                :value="getInfo.EFF_DATE"
                color="teal"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="MEMBERSHIP EXPIRY DATE:"
                :value="getInfo.LAST_D"
                color="teal"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="ACCOUNT EXPIRY DATE:"
                :value="getInfo.ACC_EXP"
                color="teal"
                readonly
                autocomplete="nope"
            />
            <!-- <v-text-field
                label="PAID UNTIL:"
                :value="getInfo.PD_UNTIL"
                color="teal"
                readonly
                autocomplete="nope"
            /> -->
            <v-text-field
                label="MSU:"
                :value="getInfo.MSU"
                color="teal"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="STATUS:"
                :value="getInfo.STATUS"
                color="teal"
                readonly
                autocomplete="nope"
            />
        </template>
    </FormCard>
</template>

<script>
import FormCard from './Other/FormCard.vue'
import { mapGetters } from 'vuex'
import { moment } from '../../../../utils/date-shim'

export default {
    components: {
        FormCard
    },
    computed: {
        ...mapGetters(['getUserConsultInfo']),
        getInfo: {
            get() {
                return {
                    ACCOUNT: this.getUserConsultInfo.ACCOUNT,
                    EFF_DATE: moment(this.getUserConsultInfo.EFF_DATE).utcOffset('+0800').format('DD MMMM YYYY'),
                    LAST_D: moment(this.getUserConsultInfo.LAST_D).utcOffset('+0800').format('DD MMMM YYYY'),
                    ACC_EXP: moment(this.getUserConsultInfo.ACC_EXP).utcOffset('+0800').format('DD MMMM YYYY'),
                    PD_UNTIL: moment(this.getUserConsultInfo.PD_UNTIL).utcOffset('+0800').format('DD MMMM YYYY'),
                    MSU: `${this.getUserConsultInfo.MSU} - ${this.getUserConsultInfo.ACCESS_DESCRIPTION}`,
                    STATUS: this.getUserConsultInfo.STATUS
                }
            }
        }
    }
}
</script>
